import { useTranslation } from "react-i18next";
import { NavBar } from "../components/navBar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import GearHeadings from "../ui/gearheadings";
import GearParagraph from "../ui/gearparagraph";
import yomiLogo from "../assets/yomi.png";
import spaghettethLogo from "../assets/spaghetteth_logo.png";
import ereticoLogo from "../assets/eretico_logo.png";

const About = () => {
  const { t } = useTranslation();

  return (
    <div
      className="h-screen flex flex-col"
      style={{
        maxHeight: "100dvh",
        background:
          "linear-gradient(180deg, #1A0F2E 0%, #17092E 50%, #1A0F2E 100%)",
      }}
    >
      <NavBar />
      <main className="max-h-screen pt-[120px] px-6 py-12 overflow-y-auto">
        {/* Hero Section */}
        <section className="max-w-[768px] flex flex-col gap-8 items-center justify-center mx-auto text-center mb-16">
          <GearHeadings variant="h1" className="text-white">
            {t("pages.about.title", "About GearSurfing")}
          </GearHeadings>
          <GearParagraph
            variant="large"
            className="text-white leading-relaxed mx-auto"
          >
            {t(
              "pages.about.description",
              "GearSurfing è la piattaforma che aiuta i musicisti a viaggiare leggeri. Trovi strumenti ovunque tu vada e condividi i tuoi quando restano fermi. Una community fondata sulla fiducia, la condivisione e la libertà di suonare senza confini."
            )}
          </GearParagraph>
        </section>

        {/* How It Works Section */}
        <section className="max-w-6xl mx-auto mb-16">
          <GearHeadings
            variant="h2"
            className="text-secondary text-center mb-8"
          >
            {t("pages.about.howItWorks", "Come Funziona")}
          </GearHeadings>
          <div className="grid md:grid-cols-2 gap-6">
            {/* For Venues Card */}
            <div
              style={{
                border: "1px solid #6E11B04D",
              }}
              className="bg-[#2C0F4A] rounded-[14px] p-6 text-white"
            >
              <div className="flex items-center justify-center w-12 h-12 bg-secondary rounded-full mb-6">
                <img
                  src={"/icons/search.svg"}
                  alt="search"
                  className="text-white text-2xl"
                />
              </div>
              <GearHeadings variant="h3" className="mb-4 font-[500]">
                {t("pages.about.forVenues", "Per i Locali")}
              </GearHeadings>
              <GearParagraph
                variant="small"
                className="text-white/90 leading-relaxed"
              >
                {t(
                  "pages.about.forVenuesDescription",
                  "Registra il tuo spazio e rendilo visibile ai musicisti. Indica le attrezzature disponibili, le opzioni di alloggio e tutto ciò che rende unica la tua location."
                )}
              </GearParagraph>
            </div>

            {/* For Owners Card */}
            <div
              style={{
                border: "1px solid #6E11B04D",
              }}
              className="bg-[#2C0F4A] rounded-[14px] p-6 text-white"
            >
              <div className="flex items-center justify-center w-12 h-12 bg-secondary rounded-full mb-6">
                <img
                  src={"/icons/music.svg"}
                  alt="music"
                  className="text-white text-2xl"
                />
              </div>
              <GearHeadings variant="h3" className="mb-4 font-[500]">
                {t("pages.about.forOwners", "Per i Proprietari")}
              </GearHeadings>
              <GearParagraph
                variant="small"
                className="text-white/90 leading-relaxed"
              >
                {t(
                  "pages.about.forOwnersDescription",
                  "Condividi la tua attrezzatura musicale con la community. Elenca i tuoi strumenti e rendili disponibili ai musicisti che viaggiano e hanno bisogno di suonare."
                )}
              </GearParagraph>
            </div>
          </div>
        </section>

        {/* Key Features Section */}
        <section className="max-w-6xl mx-auto mb-16">
          <GearHeadings
            variant="h2"
            className="text-secondary text-center mb-8"
          >
            {t("pages.about.keyFeatures", "Caratteristiche Principali")}
          </GearHeadings>
          <div className="grid md:grid-cols-3 gap-5">
            {/* Feature Card 1 */}
            <div className="about-card">
              <img src={"/icons/map.svg"} alt="map" />
              <GearHeadings
                variant="h5"
                className="text-center text-[18px] font-[500] mt-4"
              >
                {t(
                  "pages.about.mapBasedDiscovery",
                  "Scoperta Basata sulla Mappa"
                )}
              </GearHeadings>
              <GearParagraph
                variant="medium"
                className="text-center leading-relaxed"
              >
                {t(
                  "pages.about.mapBasedDiscoveryDescription",
                  "Esplora strumenti e locali musicali vicino a te, o ovunque tu stia andando. Una mappa interattiva in tempo reale ti aiuta a trovare ciò di cui hai bisogno, quando ne hai bisogno."
                )}
              </GearParagraph>
            </div>

            {/* Feature Card 2 */}
            <div className="about-card">
              <img src={"/icons/map.svg"} alt="map" />
              <GearHeadings
                variant="h5"
                className="text-center text-[18px] font-[500] mt-4"
              >
                {t("pages.about.verifiedCommunity", "Community Verificata")}
              </GearHeadings>
              <GearParagraph
                variant="medium"
                className="text-center leading-relaxed"
              >
                {t(
                  "pages.about.verifiedCommunityDescription",
                  "Ogni profilo è verificato: musicisti, locali e fornitori di attrezzature. GearSurfing è costruito sulla fiducia, la passione e l'esperienza condivisa."
                )}
              </GearParagraph>
            </div>

            {/* Feature Card 3 */}
            <div className="about-card">
              <img src={"/icons/map.svg"} alt="plus-circle" />
              <GearHeadings
                variant="h5"
                className="text-center text-[18px] font-[500] mt-4"
              >
                {t(
                  "pages.about.addYourGearOrVenue",
                  "Aggiungi la Tua Attrezzatura o Locale"
                )}
              </GearHeadings>
              <GearParagraph
                variant="medium"
                className="text-center leading-relaxed"
              >
                {t(
                  "pages.about.addYourGearOrVenueDescription",
                  "Condividi i tuoi strumenti o elenca il tuo spazio musicale in pochi clic. Carica foto, dettagli e disponibilità proprio come Vinted, ma per attrezzature musicali."
                )}
              </GearParagraph>
            </div>

            {/* Feature Card 4 */}
            <div className="about-card">
              <img src={"/icons/map.svg"} alt="filter" />
              <GearHeadings
                variant="h5"
                className="text-center text-[18px] font-[500] mt-4"
              >
                {t("pages.about.smartFilters", "Filtri Intelligenti")}
              </GearHeadings>
              <GearParagraph
                variant="medium"
                className="text-center leading-relaxed"
              >
                {t(
                  "pages.about.smartFiltersDescription",
                  "Filtra per tipo di attrezzatura, posizione, fascia di prezzo o date di disponibilità. Trova esattamente ciò che si adatta al tuo tour, sessione in studio o prossimo concerto."
                )}
              </GearParagraph>
            </div>

            {/* Feature Card 5 */}
            <div className="about-card">
              <img src={"/icons/map.svg"} alt="shield-alt" />
              <GearHeadings
                variant="h5"
                className="text-center text-[18px] font-[500] mt-4"
              >
                {t(
                  "pages.about.securePaymentsInsurance",
                  "Pagamenti Sicuri e Assicurazione"
                )}
              </GearHeadings>
              <GearParagraph
                variant="medium"
                className="text-center leading-relaxed"
              >
                {t(
                  "pages.about.securePaymentsInsuranceDescription",
                  "Protezione dei pagamenti integrata e assicurazione sia per i prestatori che per i noleggiatori. Gioca in sicurezza mentre condividi ciò che ami."
                )}
              </GearParagraph>
            </div>

            {/* Feature Card 6 */}
            <div className="about-card">
              <img src={"/icons/map.svg"} alt="user-circle" />
              <GearHeadings
                variant="h5"
                className="text-center text-[18px] font-[500] mt-4"
              >
                {t("pages.about.profileContributions", "Profilo e Contributi")}
              </GearHeadings>
              <GearParagraph
                variant="medium"
                className="text-center leading-relaxed"
              >
                {t(
                  "pages.about.profileContributionsDescription",
                  "Gestisci i tuoi annunci, traccia la tua attività e costruisci la tua reputazione. Ogni elemento condiviso e ogni recensione aiuta a far crescere la tua presenza nella community."
                )}
              </GearParagraph>
            </div>
          </div>
        </section>

        {/* Why Choose GearSurfing Section */}
        <section
          className="about-card max-w-6xl mx-auto"
          style={{ alignItems: "start" }}
        >
          <GearHeadings variant="h2" className="text-secondary mb-2 text-left">
            {t(
              "pages.about.whyChooseGearSurfing",
              "Perché Scegliere GearSurfing?"
            )}
          </GearHeadings>
          <GearParagraph
            variant="large"
            className="text-white leading-relaxed mb-6 max-w-4xl"
          >
            {t(
              "pages.about.whyChooseDescription",
              "Perché è fatto da musicisti, per musicisti. GearSurfing è nato dall'idea che viaggiare leggeri non dovrebbe significare suonare in piccolo. È la libertà di muoversi, connettersi e creare senza confini o valigie pesanti."
            )}
          </GearParagraph>
          <ul className="text-white space-y-3 mb-6">
            <li className="flex items-start">
              <span className="mr-3">•</span>
              <span>
                {t(
                  "pages.about.benefit1",
                  "Scopri strumenti e spazi ovunque tu vada"
                )}
              </span>
            </li>
            <li className="flex items-start">
              <span className="mr-3">•</span>
              <span>
                {t(
                  "pages.about.benefit2",
                  "Dai un nuovo scopo alle attrezzature inutilizzate"
                )}
              </span>
            </li>
            <li className="flex items-start">
              <span className="mr-3">•</span>
              <span>
                {t(
                  "pages.about.benefit3",
                  "Connettiti con artisti e locali locali"
                )}
              </span>
            </li>
            <li className="flex items-start">
              <span className="mr-3">•</span>
              <span>
                {t(
                  "pages.about.benefit4",
                  "Riduci l'impatto ambientale dei tour"
                )}
              </span>
            </li>
          </ul>
          <GearParagraph
            variant="large"
            className="text-white leading-relaxed max-w-4xl"
          >
            {t(
              "pages.about.whyChooseConclusion",
              "È più di una piattaforma - è un movimento costruito sulla fiducia, la creatività e la gioia di condividere la musica."
            )}
          </GearParagraph>
        </section>

        {/* Sponsors Section */}
        <section className="max-w-6xl w-full mb-16 mx-auto mt-8">
          <div className="about-card mx-auto">
            <GearHeadings variant="h3" className="text-secondary mb-10">
              {t("pages.about.supportedBy", "Supported By")}
            </GearHeadings>

            <div className="flex flex-wrap items-center justify-center gap-12 sm:gap-20">
              {/* YOMI */}
              <a
                href="http://www.yomi.digital/"
                target="_blank"
                rel="noopener noreferrer"
                className="group transition-all duration-300 transform hover:scale-110"
              >
                <img
                  src={yomiLogo}
                  alt="YOMI"
                  className="h-4 sm:h-8 w-auto object-contain group-hover:opacity-100 transition-opacity"
                />
              </a>

              {/* SpaghettETH */}
              <a
                href="https://www.spaghett-eth.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="group transition-all duration-300 transform hover:scale-110"
              >
                <img
                  src={spaghettethLogo}
                  alt="SpaghettETH"
                  className="h-14 sm:h-20 w-auto object-contain group-hover:opacity-100 transition-opacity"
                />
              </a>

              {/* Eretico */}
              <a
                href="https://lereticobooking.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="group transition-all duration-300 transform hover:scale-110"
              >
                <img
                  src={ereticoLogo}
                  alt="Eretico"
                  className="h-10 sm:h-16 w-auto object-contain group-hover:opacity-100 transition-opacity"
                />
              </a>
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="max-w-6xl mx-auto text-center my-16">
          <GearHeadings variant="h5" className="text-white mb-4">
            {t(
              "pages.about.readyToStart",
              "Pronto a iniziare a fare surf per le attrezzature?"
            )}
          </GearHeadings>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="bg-secondary hover:bg-secondary-600 text-white px-8 py-3 rounded-full font-[500] text-lg transition-all"
            >
              {t("pages.about.browseTheMap", "Esplora la Mappa")}
            </Link>
            <Link
              to="/"
              className="border-2 border-white text-white hover:bg-white hover:text-[#2F0D68] px-8 py-3 rounded-full font-semibold text-lg transition-all"
            >
              {t("pages.about.listYourGear", "Elenca la Tua Attrezzatura")}
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default About;
